"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analysisGateDispatchSchema = exports.AnalysisGateDispatch = void 0;
const z = require("zod");
var AnalysisGateDispatch;
(function (AnalysisGateDispatch) {
    AnalysisGateDispatch["Started"] = "started";
    AnalysisGateDispatch["AlreadyRunning"] = "already_running";
    AnalysisGateDispatch["NotStarted"] = "not_started";
})(AnalysisGateDispatch || (exports.AnalysisGateDispatch = AnalysisGateDispatch = {}));
exports.analysisGateDispatchSchema = z.nativeEnum(AnalysisGateDispatch);
//# sourceMappingURL=analysis-gate-dispatch.js.map